export const DEFAULT_STREAM_SAFETY_POLL_INTERVAL_MS = 30_000

export function resolveStreamSafetyPollIntervalMs(
  env: Record<string, unknown> = import.meta.env as Record<string, unknown>,
): number {
  try {
    const raw = Number(env.VITE_STREAM_SAFETY_POLL_MS)
    if (Number.isFinite(raw) && raw > 0)
      return raw
    return DEFAULT_STREAM_SAFETY_POLL_INTERVAL_MS
  }
  catch {
    return DEFAULT_STREAM_SAFETY_POLL_INTERVAL_MS
  }
}

export const STREAM_SAFETY_POLL_INTERVAL_MS = resolveStreamSafetyPollIntervalMs()

export function shouldApplyRevision(
  lastApplied: number | null,
  incoming: number | null,
): boolean {
  if (incoming === null)
    return true
  return lastApplied === null || incoming > lastApplied
}

export function advanceAppliedRevision(
  lastApplied: number | null,
  incoming: number | null,
): number | null {
  if (incoming === null)
    return lastApplied
  if (lastApplied === null)
    return incoming
  return Math.max(lastApplied, incoming)
}
